import { therapyPlanningAction } from '../../actions/constant';

const {
  VERIFY_MDS_PPS_SUCCESS,
  VERIFY_MDS_PPS_FAILURE,
  VERIFY_MDS_PPS_LOADING,
  VERIFY_MDS_PPS_RESET,
} = therapyPlanningAction;

const initialState: any = {
  response: null,
  loading: false,
  isError: false,
};

export const verifyMdsPpsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case VERIFY_MDS_PPS_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isError: false,
      };
    case VERIFY_MDS_PPS_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isError: true,
      };
    case VERIFY_MDS_PPS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case VERIFY_MDS_PPS_RESET:
      return initialState;
    default:
      return state;
  }
};
